// The sim's RevealFog seam (a local player's units lift the fog map as the sim runs).
// Shared by the replay viewer AND its background prewarm worker so both produce IDENTICAL,
// fog-side-specific snapshots (the snapshot serializes the fog map). Fog reveal is per-client
// and UNHASHED — it never perturbs the lockstep hash, so it can't affect determinism.
import { grvlp, grvlpLarge } from '../../../sim/src/sim/fogmap.ts';

export const fogHost = {
  RevealFog(gob: unknown, fLarge: boolean, tx: number, ty: number): void {
    (
      gob as { ctx: { fogm: { RevealPattern(tx: number, ty: number, p: unknown): void } } }
    ).ctx.fogm.RevealPattern(tx, ty, fLarge ? grvlpLarge : grvlp);
  },
};
